module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [(_vm.isLoggedIn && !_vm.error) ? _c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "mini-variant": _vm.miniVariant,
      "clipped": true,
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', [_vm._l((_vm.items), function(item, i) {
    return _c('v-list-tile', {
      key: i,
      attrs: {
        "to": item.link,
        "value": "true",
        "exact": "",
        "activeClass": ""
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "activeClass": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s('exit_to_app')
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s('Abmelden')
    }
  })], 1)], 1)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn && !_vm.error) ? _c('v-toolbar', {
    attrs: {
      "fixed": "",
      "app": "",
      "clipped-left": true
    }
  }, [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn && !_vm.error) ? _c('v-content', [_c('router-view')], 1) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn && !_vm.error) ? _c('v-footer', {
    attrs: {
      "fixed": _vm.fixed,
      "app": ""
    }
  }, [_c('span', [_vm._v("© 2017")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoggedIn && !_vm.error) ? _c('v-content', [_c('v-login')], 1) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('v-content', [_c('v-dialog', {
    attrs: {
      "value": true,
      "persistent": "",
      "max-width": "350"
    }
  }, [_c('v-card', [_c('v-card-text', [_vm._v(_vm._s(_vm.error.message))]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.closeError
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfbca2c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 588
// module chunks = 1